import { Component, OnInit, HostBinding, Input } from '@angular/core';
import IBuilding = ZoningAPI.IBuilding;
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-object-to-table',
    templateUrl: './object-to-table.component.html',
    styleUrls: ['./object-to-table.component.scss']
})
export class ObjectToTableComponent implements OnInit {
    @HostBinding('class')
    hostClass = 'object-to-table';

    @Input()
    dictionary: object;

    @Input()
    naFields: string[] = [];

    @Input()
    emptyArraysAsNA: boolean = false;

    @Input()
    source: IBuilding;

    @Input()
    showEmptyFields = true;

    columnsToDisplay = ['parameter', 'value'];

    private _filteredDictionary = {};

    constructor() {}

    ngOnInit() {
        this.filteredDictionary = this.dictionary;
    }

    set filteredDictionary(_dictionary) {
        if (this.showEmptyFields) {
            this._filteredDictionary = _.clone(this.dictionary);
        }

        _.forOwn(this.dictionary, (name, key) => {
            const value = this.getValue(key);
            if (value !== null && value !== undefined) {
                this._filteredDictionary[key] = name;
            }
        });
    }

    get filteredDictionary() {
        return this._filteredDictionary;
    }

    getValue(key) {
        return !!this.source
            ? this.isNAField(key) &&
              (this.source[key] === -1 ||
                  (this.emptyArraysAsNA && _.isArray(this.source[key]) && _.isEmpty(this.source[key])))
                ? 'N/A'
                : _.isArray(this.source[key])
                ? this.source[key].join(', ')
                : this.source[key]
            : null;
    }

    isNAField(fieldName: string) {
        return this.naFields.includes(fieldName);
    }

    noSort() {
        return 1;
    }
}
